import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (param) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_WORKER_DISPATCH',
    method: 'GET',
  });

  useEffect(() => {
    if (param) {
      let url = `/api/devices_all/workers_all/dispatch`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return data;
});
